var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),(_vm.$store.state.user?_vm.$store.state.user.bar:false)?_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'Dashboard',
            path: '/dashboard',
            icon: 'ni ni-tv-2 text-primary',
          }}}),(_vm.$store.state.user.lxvl < 2)?_c('sidebar-item',{attrs:{"link":{
                name: 'Proyectos',
                path: '/proyectos',
                icon: 'ni ni-box-2 text-orange'
                }}}):_vm._e(),(_vm.$store.state.user.lxvl < 2)?_c('sidebar-item',{attrs:{"link":{
                name: 'HerramientaSNF',
                path: '/herramienta',
                icon: 'ni ni-box-2 text-orange'
                }}}):_vm._e(),(_vm.$store.state.user.lxvl===0)?_c('sidebar-item',{attrs:{"link":{
                name: 'Configuración',
                path: '/profile',
                icon: 'ni ni-settings text-blue'
                }}},[_c('sidebar-item',{attrs:{"link":{
                      name: 'Usuarios',
                      path: '/usuarios',
                      icon: 'ni ni-settings text-blue'
                      }}})],1):_vm._e()],1)],2):_vm._e(),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }